import { armarParametros } from "../helpers/armarParametros";
import { fetchConToken, fetchConTokenMultipleFile } from "../helpers/fetch";

const trasladosService = {
    getSolicitud: (id) => fetchConToken(`SolicitudesTraslados/${id}`),
    getInfoAfiliadoSolicitud: (idAfiliado) => fetchConToken(`AfiliadosTraslados/${idAfiliado}`),
    getSolicitudes: (search) => fetchConToken(`SolicitudesTraslados/Search${armarParametros(search)}`),
    postSolicitud: (data) => fetchConToken(`SolicitudesTraslados`, data, "POST"),
    putSolicitud: ({id, ...data}) => fetchConToken(`SolicitudesTraslados/${id}`, data, "PUT"),
    administracionSolicitud: (id, idEstado) => fetchConToken(`SolicitudesTraslados/Administracion/${id}/${idEstado}`, {}, "PUT"),
    getNotasTraslado: (idTraslado) => fetchConToken(`NotasTraslados/${idTraslado}`),
    postNotaTraslado: (data) => fetchConToken(`NotasTraslados`, data, "POST"),
    putNotaTraslado: (data) => fetchConToken(`NotasTraslados`, data, "PUT"),
    deleteNotaTraslado: (idNota) => fetchConToken(`NotasTraslados/${idNota}`, {}, "DELETE"),

    getAllSolicitudesTomadas: () => fetchConToken(`SolicitudesTraslados/GetAllSolicitudesTomadas`),
    getByUserSolicitudesTomadas: () => fetchConToken(`SolicitudesTraslados/GetByUserSolicitudesTomadas`),
    getTrackingSolicitud: (idSolicitud) => fetchConToken(`SolicitudesTraslados/Tracking/${idSolicitud}`),
    postSolicitudTomada: (id) =>  fetchConToken(`SolicitudesTraslados/SolicitudesTomadas/${id}`, {}, "POST"),
    deleteSolicitudTomada: (id) => fetchConToken(`SolicitudesTraslados/SolicitudesTomadas/${id}`, {}, "DELETE"),
    cambiarEstadoSolicitud: ({id, ...data}) => fetchConToken(`SolicitudesTraslados/EstadoSolicitud/${id}`, data, "PUT"),
    deleteSolicitudEnCarga: (id) => fetchConToken(`SolicitudesTraslados/SolicitudEnCarga/${id}`, {}, "DELETE"),

    getTipoDocSolicitudes: () => fetchConToken(`TipoDocumentacionSolicitudTraslados`),
    postTipoDocSolicitudes: (data) => fetchConToken(`TipoDocumentacionSolicitudTraslados`, data, "POST"),
    putTipoDocSolicitudes: ({id, ...data}) => fetchConToken(`TipoDocumentacionSolicitudTraslados/${id}`, data, "PUT"),
    deleteTipoDocSolicitudes: (id) => fetchConToken(`TipoDocumentacionSolicitudTraslados/${id}`, {}, "DELETE"),

    afiliaciones: {
        putContactoAfiliado: ({idAfiliado, ...data}) => fetchConToken(`AfiliadosTraslados/${idAfiliado}`, data, "PUT"),
    },

    contratos: {
        getEfectores: (codNom) => fetchConToken(`EfectorTraslados/Search${armarParametros({codNom})}`),
        getMedicos: (idEfectorFacturacion) => fetchConToken(`MedicoTraslados/${idEfectorFacturacion}`),
        getDomiciliosMedico: (idMedico) => fetchConToken(`MedicoTraslados/Domicilios/${idMedico}`),
    },

    files: {
        getPdf: (search) => fetchConToken(`ArchivosTraslados/Search${armarParametros(search)}`),
        getPdfSolicitud: (idSolicitud) => fetchConToken(`SolicitudesTraslados/generarPdf/${idSolicitud}`),
    },

    uploadDocumentacionSolicitud: (file, idTipoDoc, idSolicitud) => fetchConTokenMultipleFile(`DocumentacionSolicitudesTraslados/${idTipoDoc}/${idSolicitud}`, file),
    deleteDocumentacionSolicitud: (id) => fetchConToken(`DocumentacionSolicitudesTraslados/${id}`, {}, "DELETE"),
    
    // DIM
    getTiposTraslados: () => fetchConToken(`DimTraslados/TipoTraslado`),
    getAccesorios: () => fetchConToken(`DimTraslados/Accesorios`),
    getCausasTraslados: () => fetchConToken(`DimTraslados/Causas`),
    getMotivosTraslados: () => fetchConToken(`DimTraslados/Motivos`),
    getSectoresTraslados: () => fetchConToken(`DimTraslados/Sectores`),
    getTipoSolicitudes: () => fetchConToken(`DimTraslados/TipoSolicitudes`),
    getEstados: () => fetchConToken(`DimTraslados/EstadosTraslados`),
    getCodigosTraslados: () => fetchConToken(`DimTraslados/CodigosTraslados`),
    getTipoPrestaciones: () => fetchConToken(`DimTraslados/TipoPrestaciones`),
    getTipoTracking: () => fetchConToken(`DimTraslados/TipoTracking`),
};

export default trasladosService;